import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@winnin/winnin_ui.components.button'
import { Image } from '@winnin/winnin_ui.components.image'
import { Title } from '@winnin/winnin_ui.components.title'

import IllustrationModalMobile from 'assets/images/svg/Illustration-modal-mobile.svg'
import { useIsMobileAllowedRoute, useIsMobileDevice, useLockBodyScroll } from 'hooks'
import { useTranslate } from 'lib/tolgee'
import { PanelStore } from 'stores'
import { TOLGEE_GLOBALS } from 'utils'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

import translations from './translations'

import './styles.scss'

const MobileNotAllowedRouteModal = () => {
  const workspaceId = Object(PanelStore?.selectedPanel)?.id

  const t = useTranslate()
  const history = useHistory()

  const isMobileDevice = useIsMobileDevice()
  const isRouteAllowedOnMobile = useIsMobileAllowedRoute()
  const [lockScroll, unlockScroll] = useLockBodyScroll()

  const shouldShowModal = isMobileDevice && !isRouteAllowedOnMobile

  useEffect(() => {
    if (shouldShowModal) {
      lockScroll()
    }

    return () => {
      unlockScroll()
    }
  }, [shouldShowModal, lockScroll, unlockScroll])

  const handleClickOnContinueOnMobileDevice = () => {
    const soaRoute = getRoute(PATHNAMES.WORKSPACE_SOA, { panelId: workspaceId })
    history.push(soaRoute)
  }

  if (!shouldShowModal) {
    return null
  }

  return (
    <div className="MobileNotAllowedRouteModal">
      <div className="MobileNotAllowedRouteModal-content">
        <div className="MobileNotAllowedRouteModal-illustration">
          <Image src={IllustrationModalMobile} alt={t(translations.illustrationDescription)} />
        </div>

        <div className="MobileNotAllowedRouteModal-body">
          <Title tag="h2" className="MobileNotAllowedRouteModal-title">
            {t(translations.title)}
          </Title>
          <p className="MobileNotAllowedRouteModal-description">{t(translations.description)}</p>
        </div>

        <div className="MobileNotAllowedRouteModal-divider">
          <div>{t(TOLGEE_GLOBALS.or)}</div>
        </div>

        <div className="MobileNotAllowedRouteModal-actions">
          <Button appearance="outline" onClick={handleClickOnContinueOnMobileDevice}>
            {t(translations.continueOnThisDevice)}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default MobileNotAllowedRouteModal
